import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { composeFormData } from '@/utils'

import { Manager, useInvalidateManagers } from './get-managers'

export type UpdateManagerRequest = {
  avatar?: File
  firstName: string
  id: number
  lastName: string
}

// Note: email is intentionally not sent - BE lets an Administrator change it, which would break the account's login
export const updateManager = async ({ id, ...data }: UpdateManagerRequest) => {
  const response = await authAPI.put<Manager>(`/manager/${id}`, composeFormData(data), {
    headers: { 'content-type': 'multipart/form-data' },
  })
  return response.data
}

export const useUpdateManager = () => {
  const invalidateManagers = useInvalidateManagers()

  return useMutation({
    mutationFn: updateManager,
    onSuccess: invalidateManagers,
  })
}
